import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Paging } from '../models/page';
import { ResponseModel } from '../models/response-model';
import { TicketType } from '../models/ticket-type';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})
export class TicketTypeService {

  constructor(private readonly http: HttpClient, private configService: ConfigurationService) { }
  private readonly url = `${environment.url}/ticketTypes`;

  readTicketTypes(isDelivery?: boolean, isEquipmentProcess?: boolean) {
    let params = new HttpParams().append("page", "0").append("pageSize", "99999999").append("salesOrg", this.configService.readSelectedBranchAndSalesOrg().salesOrg.code);
    params = isDelivery != undefined ? params.append("isDelivery", isDelivery.toString()) : params;
    params = isEquipmentProcess != undefined ? params.append("isEquipmentProcess", isEquipmentProcess.toString()) : params;

    return this.http.get<ResponseModel<Paging<Array<TicketType>>>>(this.url, { params });
  }

  readTicketType(code: string) {
    return this.http.get<ResponseModel<TicketType>>(`${this.url}/${code}`);
  }
}
